import React from 'react';
import { AUIModal } from '@ancert/aui-modal';
import { arrayOf, func, shape } from 'prop-types';
import { useNotification } from '@ancert/aui-notification-context';
import { deleteUser } from '../../../../services/user.service';

const ModalEliminarUsuario = ({ idsUsuariosEliminar, onClose, reload, listadoUsuarios }) => {
  const { openNotification } = useNotification();
  const eliminarUsuarios = async () => {
    const listaPromesas = idsUsuariosEliminar.map((id) => deleteUser(id));

    await Promise.all(listaPromesas)
      .then((listaResponses) => {
        const indexError = listaResponses.findIndex((res) => res.value?.status !== 200);

        if (indexError > 0) {
          const userError = listadoUsuarios.find(
            (us) => us.id.toString() === idsUsuariosEliminar[indexError].toString()
          );
          const nombreCompleto = userError?.name
            ? `${userError?.name} ${userError?.lastname1} ${userError?.lastname2 || ''}`
            : 'Anónimo';
          openNotification({
            title: 'Eliminar usuario',
            content: `Error al eliminar el usuario ${nombreCompleto}`,
            type: 'error',
            centerButtons: true,
          });
        } else {
          openNotification({
            title: 'Eliminar usuario',
            content: `Usuario${idsUsuariosEliminar?.length > 1 ? 's' : ''} eliminado${
              idsUsuariosEliminar?.length > 1 ? 's' : ''
            } correctamente`,
            type: 'success',
            centerButtons: true,
          });
        }
        onClose();
        reload();
      })
      .catch((error) =>
        openNotification({
          title: 'Eliminar usuario',
          content: error || 'Error al eliminar usuarios',
          type: 'error',
          centerButtons: true,
        })
      );
  };
  return (
    <AUIModal
      className="modal-eliminar-usuario"
      size="xs"
      title="Confirmar eliminación"
      show={idsUsuariosEliminar}
      onClose={onClose}
      actionButtons={[
        {
          id: 'danger',
          mode: 'danger',
          label: 'Eliminar',
          onClick: eliminarUsuarios,
        },
        {
          id: 'tertiary',
          mode: 'tertiary',
          label: 'Cancelar',
          onClick: onClose,
        },
      ]}
    >
      <p>
        Se dispone a eliminar {idsUsuariosEliminar?.length} usuario{idsUsuariosEliminar?.length > 1 ? 's' : ''}. Esta
        acción es irreversible y no se puede deshacer.
      </p>
      <p>¿Estás seguro?</p>
    </AUIModal>
  );
};
ModalEliminarUsuario.propTypes = {
  idsUsuariosEliminar: arrayOf(shape({})),
  listadoUsuarios: arrayOf(shape({})).isRequired,
  onClose: func.isRequired,
  reload: func.isRequired,
};
ModalEliminarUsuario.defaultProps = {
  idsUsuariosEliminar: [],
};
export default ModalEliminarUsuario;
